import React from "react";
import { Box, CircularProgress, Container, Typography } from "@mui/material";
import { FilterList } from "components/FilterList";
import { HeaderApp } from "components/Header";
import * as Styled from "./styles";
import { CardList } from "components/CardList";
import { IPageHome, useAuth } from "shared/providers/auth";
import { FaRegCalendarTimes } from "react-icons/fa";

import treinamento from "shared/assets/img/Treinamento.png";
import indicadores from "shared/assets/img/indicador.png";
import controle from "shared/assets/img/icones_controle chegada.png";
import pacientes from "shared/assets/img/multiplopac.png";

import { Indicators } from "components/Indicators";
import { PatientSearch } from "components/PatientSearch";

interface IProps {
  text: string;
  image: any;
  link?: string;
  type: IPageHome;
}

const itensLink: IProps[] = [
  { text: "Meus indicadores", image: indicadores, type: "INDICATORS" },
  { text: "Controle de chegada", image: controle, type: "CONTROL" },
  { text: "Pacientes", image: pacientes, type: "PATIENTS" },
  {
    text: "Treinamentos",
    image: treinamento,
    link: "https://auth.mobiliza.com.br/?service=https://academiaorthodontic.mobiliza.com.br",
    type: "DEFAULT",
  },
];

const HomePage: React.FC = () => {
  const {
    scheduleData,
    loadingSchedule,
    showServed,
    controlArrived,
    screensHome,
    setScreensHome,
    user,
  } = useAuth();

  // Filtrando os dados agendados
  const filteredScheduleData = scheduleData
    .filter((item) => {
      if (showServed) {
        // Se showServed for falso, remove os itens com st_schedule "K"
        const hasKSchedule = item.data?.some(
          (dataItem) => dataItem.st_schedule === "K"
        );
        if (hasKSchedule) {
          return false;
        }
      }

      // Se controlArrived for "ARRIVED", filtra apenas os dataItems com st_schedule "C"
      if (controlArrived === "ARRIVED") {
        const hasCSchedule = item.data?.some(
          (dataItem) =>
            dataItem.st_schedule === "C" || dataItem.st_schedule === "T"
        );
        return hasCSchedule; // Retorna true apenas se houver um dataItem com st_schedule "C"
      }

      // Continua a lógica do freeTime se controlArrived não for "ARRIVED"
      return true;
    })
    .sort((a, b) => {
      const aPreferencial = a.data?.some((d) => d.preferencial === 1) ? 1 : 0;
      const bPreferencial = b.data?.some((d) => d.preferencial === 1) ? 1 : 0;
      return bPreferencial - aPreferencial; // Preferenciais vêm primeiro
    });

  /*const filteredScheduleData = [
    {
      time: "11:00",
      data: [
        {
          id: 88099753,
          idDent: 310463,
          pac_name: "TESTE 2707",
          isAniversario: 0,
          preferencial: 0,
          pac_id_fant: 324,
          pac_id: 2679368,
          idDent_rel: 0,
          Name_detRel: null,
          record_id: 23663,
          aname_id: 0,
          type: 1,
          dt_arrival: "13:24:02",
          dt_start: "09/06/2025 11:00:00",
          dt_end: "09/06/2025 11:10:00",
          st_schedule: "C",
          proc_name: "Manutenção",
          confirmed: 0,
          classification: 3,
          isOrto: 1,
          budget: 2217932,
          inService: 0,
          isAtrasado: 1,
          future: {
            scheduling: false,
            message: "",
          },
          pac_avatar:
            "https://orthodonticfrq.s3-sa-east-1.amazonaws.com/software2/img/fotos/2679368.png",
        },
      ],
    },
    {
      time: "11:30",
      data: [
        {
          id: 88099754,
          idDent: 310463,
          pac_name: "TESTE 2707",
          isAniversario: 0,
          preferencial: 1,
          pac_id_fant: 324,
          pac_id: 2679368,
          idDent_rel: 0,
          Name_detRel: null,
          record_id: 23663,
          aname_id: 0,
          type: 1,
          dt_arrival: "16:18:18",
          dt_start: "09/06/2025 11:30:00",
          dt_end: "09/06/2025 11:40:00",
          st_schedule: "C",
          proc_name: "Manutenção",
          confirmed: 0,
          classification: 3,
          isOrto: 1,
          budget: 2217932,
          inService: 0,
          isAtrasado: 1,
          future: {
            scheduling: false,
            message: "",
          },
          pac_avatar:
            "https://orthodonticfrq.s3-sa-east-1.amazonaws.com/software2/img/fotos/2679368.png",
        },
      ],
    },
    {
      time: "15:30",
      data: [
        {
          id: 88099758,
          idDent: 310463,
          pac_name: "TESTE 2707",
          isAniversario: 0,
          preferencial: 0,
          pac_id_fant: 324,
          pac_id: 2679368,
          idDent_rel: 0,
          Name_detRel: null,
          record_id: 23663,
          aname_id: 0,
          type: 1,
          dt_arrival: "16:18:49",
          dt_start: "09/06/2025 15:30:00",
          dt_end: "09/06/2025 15:40:00",
          st_schedule: "C",
          proc_name: "Manutenção",
          confirmed: 0,
          classification: 3,
          isOrto: 1,
          budget: 2217932,
          inService: 0,
          isAtrasado: 1,
          future: {
            scheduling: false,
            message: "",
          },
          pac_avatar:
            "https://orthodonticfrq.s3-sa-east-1.amazonaws.com/software2/img/fotos/2679368.png",
        },
      ],
    },
    {
      time: "16:30",
      data: [
        {
          id: 88099759,
          idDent: 310463,
          pac_name: "TESTE 2707",
          isAniversario: 0,
          preferencial: 1,
          pac_id_fant: 324,
          pac_id: 2679368,
          idDent_rel: 0,
          Name_detRel: null,
          record_id: 23663,
          aname_id: 0,
          type: 1,
          dt_arrival: "16:18:55",
          dt_start: "09/06/2025 16:30:00",
          dt_end: "09/06/2025 16:40:00",
          st_schedule: "C",
          proc_name: "Manutenção",
          confirmed: 0,
          classification: 3,
          isOrto: 1,
          budget: 2217932,
          inService: 0,
          isAtrasado: 0,
          future: {
            scheduling: false,
            message: "",
          },
          pac_avatar:
            "https://orthodonticfrq.s3-sa-east-1.amazonaws.com/software2/img/fotos/2679368.png",
        },
      ],
    },
  ].sort((a, b) => {
    const aPreferencial = a.data?.some((d) => d.preferencial === 1) ? 1 : 0;
    const bPreferencial = b.data?.some((d) => d.preferencial === 1) ? 1 : 0;
    return bPreferencial - aPreferencial; // Preferenciais vêm primeiro
  })*/ return (
    <>
      <HeaderApp isBack={screensHome !== "DEFAULT"} />
      <Container maxWidth="xl" sx={{ height: "100%" }}>
        {screensHome === "DEFAULT" && (
          <Styled.TopHome>
            <p>Bem-vindo!</p>
            <span>{user.data.dentist.name}</span>
          </Styled.TopHome>
        )}

        {/*screensHome !== "DEFAULT" && (
          <Styled.Back onClick={() => setScreensHome("DEFAULT")}>
            Voltar
          </Styled.Back>
        )*/}

        {screensHome === "INDICATORS" && <Indicators />}

        {screensHome === "PATIENTS" && <PatientSearch />}

        {screensHome === "CONTROL" && (
          <>
            <FilterList />
            <Styled.ScrollList>
              {loadingSchedule ? (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CircularProgress color="inherit" />
                </Box>
              ) : filteredScheduleData.length > 0 ? (
                <>
                  {/* Agrupamento com borda azul para os preferenciais */}
                  {filteredScheduleData.some((item) =>
                    item.data?.some((d) => d.preferencial === 1)
                  ) && (
                    <Box
                      border="2px solid"
                      borderColor="primary.main"
                      borderRadius={2}
                      mb={2}
                      gap="20px"
                      display="flex"
                      flexDirection="column"
                    >
                      {filteredScheduleData
                        .filter((item) =>
                          item.data?.some((d) => d.preferencial === 1)
                        )
                        .map((item, index) => (
                          <CardList data={item} key={`pref-${index}`} />
                        ))}
                    </Box>
                  )}

                  {/* Lista normal dos não preferenciais */}
                  {filteredScheduleData
                    .filter(
                      (item) => !item.data?.some((d) => d.preferencial === 1)
                    )
                    .map((item, index) => (
                      <CardList data={item} key={`norm-${index}`} />
                    ))}
                </>
              ) : (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    marginTop: "15px",
                  }}
                >
                  <FaRegCalendarTimes size={24} />
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      marginTop: "5px",
                    }}
                  >
                    Nenhum agendamento encontrado.
                  </Typography>
                </Box>
              )}
            </Styled.ScrollList>
          </>
        )}

        {screensHome === "DEFAULT" && (
          <Styled.BoxItem>
            {itensLink.map((item, index) => (
              <Styled.Item
                key={index}
                onClick={
                  item.link
                    ? () => window.open(item.link, "_blank")
                    : () => setScreensHome(item.type)
                }
              >
                <img src={item.image} alt={item.text} />
                <p>{item.text}</p>
              </Styled.Item>
            ))}
          </Styled.BoxItem>
        )}
      </Container>
    </>
  );
};

export { HomePage };
